<template>
    <div class="questionnaire-edit-header" v-if="questionnaireIn">
        <h3 class="title">
            {{questionnaireIn.title}}
        </h3>

        <div class="questionnaire-edit-tools">
            <div class="context-nav questionnaire-header-nav-context">
                <b-dropdown no-caret variant="primary" right toggle-class="questionnaire-header-nav-context-menu" class="ellipsis-nav questionnaire-header-nav">
                    <template v-slot:button-content>
                        <i class="fas fa-ellipsis-v"></i>
                    </template>
                    <b-dropdown-item class="edit-questionnaire-form" v-b-modal="'questionnaire-name-edit-modal'"
                                     @click="$event.stopPropagation()">
                        <i class="btn-edit"></i>{{$t('questionnaire.change_name')}}
                    </b-dropdown-item>
                </b-dropdown>

                <design-2021-questionnaire-edit-title-modal-component
                    :questionnaire-in="questionnaireIn"
                ></design-2021-questionnaire-edit-title-modal-component>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "design-2021-questionnaire-edit-title-component",
    props: [
        'questionnaireIn'
    ]
}
</script>

<style scoped lang="scss">
    .questionnaire-edit-header {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: nowrap;
        flex: 1 0 100%;
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');

        .title {
            font-weight: $font-weight-bold;
            margin-bottom: 0;
            width: calc(100% - 51px);
        }

        .questionnaire-edit-tools {
            align-self: flex-start;
        }

        .questionnaire-header-nav-context ::v-deep {
            .questionnaire-header-nav {
                button.dropdown-toggle{
                    color: $white !important;
                    background-color: $primary;
                    padding: map-get($grid-gutter-spacing, 'eight') map-get($grid-gutter-spacing, 'fifteen');
                }

                .edit-questionnaire-form {
                    .dropdown-item {
                        display: flex;
                        align-items: center;
                    }

                    i {
                        color: $primary;
                    }
                }

                .dropdown-menu {
                    border: 1px solid $border-color;

                    li {
                        &:before,
                        i {
                            min-width: 20px;
                            margin-right: map-get($grid-gutter-spacing, 'eight');
                        }
                    }
                }
            }
        }

    }

    @media(min-width: map-get($grid-breakpoints, 'sm')){
        .questionnaire-edit-header {
            flex-wrap: nowrap;

            .title {
                width: calc(100% - 95px);
            }

            .questionnaire-edit-tools {
                flex: 0 1 auto;
                margin-left: auto;
                align-self: baseline;
            }
        }
    }
</style>
